export default {
  OCCUR: 1,      // 発生
}
